<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-05-21 23:14:06
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-11-28 00:13:36
-->
<template>
    <div class="course-content">
        <div class="title">
            <div class="title-text">热门课程</div>
            <router-link class="check-more" target="_blank" to="/courses">查看更多</router-link>
        </div>
        <div class="course-con">
            <div class="course-item" v-for="course in dataList" @click="setCourse(course)">
                <img :src="course.hotCover" alt="">
                <div class="course-new" v-if="course.newStatus === 1">新课上架</div>
                <div class="course-title">{{course.hotTitle}}</div>
                <div class="course-desc">
                    <div class="course-info">
                        <div class="course-info-top">{{course.hotDesc}}</div>
                        <div>{{course.hotContent}}</div>
                    </div>
                    <div class="course-btn">查看详情</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getHotCourseList } from '@/api/courses';
import { openWindow } from '@/utils/utils';

export default {
    name: 'HotCourse',
    components: {
    },
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        dataList:[
            {
                imgUrl:'/static/images/course1.jpg',
                id: 22,
                title: 'UE5三维地图设计教程',
                person: "火热报名中...",
                info: '全流程从无到有式教学，从此再也不怕三维地图'
            },
            {
                imgUrl:'/static/images/course2.jpg',
                id: 15,
                title: 'Unity玩家自学必修课',
                person: '760人已学习',
                info: '3D可视化必学引擎之一,大牛亲授U3D实战入门'
            },
            {
                imgUrl:'/static/images/course3.jpg',
                id: 18,
                title: '数字孪生城市设计全流程',
                person: "568人已学习",
                info: '数据处理+建模+开发对接全流程讲解'
            },
            {
                imgUrl:'/static/images/course3.jpg',
                id: 19,
                title: '数字孪生城市设计全流程',
                person: "568人已学习",
                info: '数据处理+建模+开发对接全流程讲解'
            },

        ]
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    created() {
        this.getDataList()
    },
    mounted() {
    },  
    methods: {
        setCourse(course) {
			if (!course.id) {
				return;
			}
			openWindow(`/#/courses/detail/${course.id}`)
		},
        getDataList() {
            getHotCourseList().then(res =>{
                this.dataList = res.data || []
            }).catch(err => {
                console.log('err: ', err);
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.course-content {
    width: 1600px;
    margin: 50px 0 40px 0;
    .title {
        // margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .check-more {
            color: #9DA1B5;
            cursor: pointer;
            font-weight: 400;
            font-size: 18px;
        }
        .title-text {
            color: #333333;
            font-size: 26px;
            font-weight: 600;
        }
    }
    .course-con {
        display: flex;
        flex-wrap: nowrap;
        margin-top: 20px;
        overflow: visible;

    }
    .course-item {
        background: #fff;
        flex: 1;
        height: 336px;
        margin-right: 21px;
        display: flex;
        border-radius: 8px;
        // justify-content: flex-end;
        flex-direction: column;
        cursor: pointer;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        max-width: 412px;
        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, .03), 0 8px 16px rgba(0, 0, 0, .02);
            transform: translate(0, -5px);
            transition: transform .3s;
        }
        &:nth-last-child(1) {
            margin: 0;
        }
        img {
            width: 100%;
            height: 240px;
            // border-radius: 8px;
            margin-bottom: 10px;
            z-index: 1;
        }
        .course-new {
            position: absolute;
            right: 0;
            top:0;
            width: 76px;
			height: 30px;
			background: #FA5151;
			opacity: 1;
			color: #fff;
			text-align: center;
			line-height: 30px;
			border-radius: 0 0 0 4px;
			font-size: 16px;
            z-index: 3;
        }
        .course-title {
            position: relative;
            z-index: 2;
            color: #272C40;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            padding: 0 20px 0 12px;
        }
        .course-desc {
            position: relative;
            z-index: 2;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 12px;
            overflow: hidden;
            .course-info {
                color: #8C8C8C;
                font-size: 12px;
                line-height: 22px;
                margin-right: 32px;
                // white-space: pre-wrap;
                overflow: hidden;
                .course-info-top {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .course-btn {
                width: 90px;
                flex-shrink: 0;
                height: 34px;
                background: #0057ff;
                border-radius: 6px 6px 6px 6px;
                opacity: 1;
                text-align: center;
                line-height: 34px;
                font-size: 14px;
                font-weight: 600;
                color: #fff;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .course-content {
        width: 1200px;

        .course-item {
            height: 320px;
            max-width: 301px;
            .course-desc {
                .course-info {
                    margin-right: 15px;
                }
            }
            img {
                height: 179px;
            }
        }
    }
}
// 小屏
@include mq($smaller) {
    .course-content {
        width: unset;

    }
}
</style>
